﻿{
  "createAccount": "Crea account",
  "subscription": "Abbonamento",
  "oneTimePurchase": "Acquisto una tantum",
  "billingDetails": "Dettagli fatturazione",
  "paymentDetails": "Dettagli pagamento",
  "requestAQuote": "Modulo di richiesta aziendale",
  "reviewOrder": "Rivedi ordine",
  "thankYouForYourOrder": "Grazie per l'ordine!",
  "joinTheCommunity": "Unisciti alla Community",
  "startTrial": "Inizia prova",
  "yourTrialHasEnded": "La prova è terminata",
  "taxExempt": "Esenzione fiscale",
  "taxExemptThankYou": "Caricamento avvenuto correttamente!",
  "planDetails": "Dettagli del mio abbonamento",
  "modifyPlan": "Modifica opzione",
  "modifyPaymentDetails": "Modifica dettagli pagamento",
  "redirect": "Reindirizzamento a Boardmaker",
  "perpetualTrial": "Scarica la tua versione di prova gratuita di {{trialLength}} giorni",
  "perpetualThankYou": "Il tuo software è pronto!",
  "downloads": "Scarica Boardmaker",
  "partner": "Trova un partner",
  "intro": "Seleziona un prodotto Boardmaker di seguito per scaricare la versione più aggiornata per il tuo dispositivo.",
"systemRequirements": "Requisiti di sistema",
"releaseNotes": "Note sulla versione",
"comparison": "Confronta Abbonamento e Licenza"
}
